import { IError, ILoading } from '@types';

import { SET_DEFAULT_COUNTRY, SET_ERROR, SET_FORM_SUBMITTED, SET_LOADING, SET_SCROLL_TO_ERROR } from '@store/actions';

export interface ISetDefaultCountryAction {
    type: 'SET_DEFAULT_COUNTRY';
    payload: string;
}

export interface ISetErrorAction {
    type: 'SET_ERROR';
    payload: IError | null;
}

export interface ISetFormSubmittedAction {
    type: 'SET_FORM_SUBMITTED';
    payload: boolean;
}

export interface ISetLoadingAction {
    type: 'SET_LOADING';
    payload: ILoading;
}

export interface ISetScrollToError {
    type: 'SET_SCROLL_TO_ERROR';
    payload: boolean;
}

export type StatusAction =
    | ISetDefaultCountryAction
    | ISetErrorAction
    | ISetFormSubmittedAction
    | ISetLoadingAction
    | ISetScrollToError;

export const setDefaultCountry = (data: string): ISetDefaultCountryAction => ({
    type: SET_DEFAULT_COUNTRY,
    payload: data,
});

export const setErrorAction = (data: IError | null): ISetErrorAction => ({
    type: SET_ERROR,
    payload: data,
});

export const setFormSubmittedAction = (data: boolean): ISetFormSubmittedAction => ({
    type: SET_FORM_SUBMITTED,
    payload: data,
});

export const setLoadingAction = (data: ILoading): ISetLoadingAction => ({ type: SET_LOADING, payload: data });

export const setScrollToError = (data: boolean): ISetScrollToError => ({ type: SET_SCROLL_TO_ERROR, payload: data });
